export class HyperlinkEngine {
    static #activeClassName = 'router-active';

    /**
     *
     * @return {module:url.URL}
     */
    static get currentUrl() {
        return new URL(window.location);
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {boolean}
     */
    static isCurrentLocation(linkElement) {
        return decodeURI(linkElement.href) === decodeURI(new URL(window.location).href);
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {boolean}
     */
    static isHash(linkElement) {
        return linkElement.href.match('#') !== null;
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {boolean}
     */
    static isMail(linkElement) {
        return linkElement.href.startsWith('mailto:');
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {boolean}
     */
    static isTargetBlank(linkElement) {
        return linkElement.getAttribute('target') === '_blank';
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {boolean}
     */
    static isDownload(linkElement) {
        return linkElement.hasAttribute('download');
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {boolean}
     */
    static isDropdown(linkElement) {
        return linkElement.getAttribute('data-type') === 'dropdown';
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {void}
     */
    static activate(linkElement) {
        linkElement.classList.add(this.#activeClassName);
    }

    /**
     *
     * @param linkElement {HTMLLinkElement}
     * @return {void}
     */
    static deactivate(linkElement) {
        linkElement.classList.remove(this.#activeClassName);
    }

    /**
     *
     * @return {HTMLLinkElement[]}
     */
    static findHyperlinkElements() {
        const hyperlinkElementList = [];
        for (const hyperLink of document.querySelectorAll('a')) {
            if (HyperlinkEngine.isHash(hyperLink)
                || HyperlinkEngine.isTargetBlank(hyperLink)
                || HyperlinkEngine.isMail(hyperLink)
                || HyperlinkEngine.isDropdown(hyperLink)
            ) {
                continue
            };
                hyperlinkElementList.push(hyperLink);
        }
        return hyperlinkElementList;
    }
}
